import { Tenant } from '../../Entities/App/Tenants.entity';
import { Locale } from '../../Entities/Locale/Locale.entity';
import { RegionArea } from '../../Entities/Location/RegionArea.entity';
import { InterlinkingItem } from '../../Entities/Location/RegionArea.entity';

export const getUKInterlinkedLocation = (
  locale: Locale,
  ukRegions: RegionArea[],
  tenant?: Tenant,
) => {
  const baseUrl = `${!tenant ? `${locale}/` : ''}`;

  const regionsByCountry = ukRegions.reduce(
    (acc, { country, shortName, position, postcode, id }) => {
      acc[country] = acc[country] || [];
      acc[country].push({ shortName, position: position!, postcode, id });
      return acc;
    },
    {} as {
      [country: string]: {
        shortName: string;
        position: { lat: number; lon: number };
        postcode: string;
        id: string;
      }[];
    },
  );

  const sortedInterlinkingItems: InterlinkingItem[] = Object.entries(regionsByCountry)
    .sort(([country1], [country2]) => country1.localeCompare(country2))
    .map(([country, regions]) => ({
      heading: country,
      regions: regions.map(({ shortName, id }) => ({
        name: shortName,
        url: `${baseUrl}locations/${id}`,
      })),
    }));

  return sortedInterlinkingItems;
};
export const getFRInterlinkedLocation = (locale: Locale, frAreas: RegionArea[]) => {
  const regionsByCountry = frAreas.reduce(
    (acc, { region, shortName, lat, lon, postcode, regionCode, areaCode }) => {
      acc[region!] = acc[region!] || [];
      acc[region!].push({
        shortName,
        lat: Number(lat),
        lon: Number(lon),
        postcode,
        regionCode,
        areaCode,
      });
      return acc;
    },
    {} as {
      [region: string]: {
        shortName: string;
        lat: number;
        lon: number;
        postcode: string;
        regionCode: string | undefined;
        areaCode: string | undefined;
      }[];
    },
  );

  const sortedInterlinkingItems: InterlinkingItem[] = Object.entries(regionsByCountry)
    .sort(([region1], [region2]) => region1.localeCompare(region2))
    .map(([region, areas]) => ({
      heading: region,
      regions: areas.map(({ shortName, regionCode, areaCode }) => ({
        name: shortName,
        url: `${locale}/locations/${regionCode}/${areaCode}`,
      })),
    }));
  return sortedInterlinkingItems;
};
